import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('BlokoTranslateGuard', null, { withChildren: true });
